<template>
  <v-btn x-small v-show="active">
    <v-icon small @click="restore()">mdi-restore</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    restore() {
      this.$store.dispatch('common/motlet/setZoomRestore', { id: this.id, restore: true });
    },
  },
};
</script>
